import React from 'react'

export type Variants = 'control' | `variant_${number}`

type VariantComponents<TVariantProps> = {
  [v in Variants]?: React.ComponentType<TVariantProps>
}

export type Props<TVariantProps> = {
  bucket: Variants
  default?: React.ComponentType<TVariantProps>
  name: string
  control?: React.ComponentType<TVariantProps>
  variant_1?: React.ComponentType<TVariantProps>
} & VariantComponents<TVariantProps> &
  TVariantProps

const ExperimentLoader = <TVariantProps,>(props: Props<TVariantProps>) => {
  const Component: React.ComponentType<TVariantProps> | undefined =
    props[props.bucket] ?? props.default

  if (!Component) {
    return null
  }

  return <Component {...props} />
}

export default ExperimentLoader
